"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_intl_1 = require("react-intl");
var AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");
var x_date_pickers_1 = require("@mui/x-date-pickers");
var LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
var moment_1 = __importDefault(require("moment"));
var Label_1 = __importDefault(require("../Label"));
var Validation_1 = __importDefault(require("../Validation"));
var MaterialIcon_1 = __importDefault(require("../MaterialIcon"));
var styles_1 = require("./styles");
var Calendar = function (_a) {
    var label = _a.label, required = _a.required, value = _a.value, validation = _a.validation, onChange = _a.onChange, testLabel = _a.testLabel, testId = _a.testId, props = __rest(_a, ["label", "required", "value", "validation", "onChange", "testLabel", "testId"]);
    var locale = (0, react_intl_1.useIntl)().locale;
    var handleChange = function (value) {
        var newValue = (0, moment_1.default)(value).toDate();
        if (newValue.toString() === 'Invalid Date') {
            newValue = null;
        }
        onChange(newValue);
    };
    // Create a descriptive aria-label
    var ariaLabel = label || testLabel || 'Date picker';
    return ((0, jsx_runtime_1.jsxs)(styles_1.CalendarOuterContainer, __assign({ "data-testid": "".concat(testId, "-calendar-outer-container") }, { children: [label && ((0, jsx_runtime_1.jsx)(Label_1.default, __assign({ required: required, htmlFor: "".concat(testId, "-date") }, { children: label }))), (0, jsx_runtime_1.jsx)(styles_1.CalendarContainer, __assign({ "data-testid": "".concat(testId, "-calendar-container") }, { children: (0, jsx_runtime_1.jsx)(LocalizationProvider_1.LocalizationProvider, __assign({ dateAdapter: AdapterMoment_1.AdapterMoment, adapterLocale: locale }, { children: (0, jsx_runtime_1.jsx)(x_date_pickers_1.DesktopDatePicker, __assign({ value: (0, moment_1.default)(value), onChange: handleChange }, props, { label: testLabel, "data-testid": "".concat(testId, "-date"), slots: {
                            openPickerIcon: function () { return (0, jsx_runtime_1.jsx)(MaterialIcon_1.default, { name: "calendar_month" }); },
                        }, slotProps: {
                            textField: {
                                id: "".concat(testId, "-date"),
                            },
                        }, "aria-label": ariaLabel, "aria-required": required, "aria-invalid": !!validation })) })) })), validation && (0, jsx_runtime_1.jsx)(Validation_1.default, __assign({ type: "error" }, { children: validation }))] })));
};
exports.default = Calendar;
